import { create } from 'zustand'

interface CommandPaletteState {
  /** Whether the spotlight dialog is showing. */
  open: boolean
  setPaletteOpen: (open: boolean) => void
  openPalette: () => void
  togglePalette: () => void
}

/**
 * Open/closed state for the command palette.
 *
 * A store rather than component state because the dialog is mounted once in
 * `AuthLayout`, outside the tab tree, while the things that open it live
 * inside it — today the Search button on the org home screen, tomorrow
 * anything else that wants to hand the user the palette. Neither side can
 * reach the other's state through props.
 *
 * Not persisted: a palette left open when the browser closed should not
 * greet the user on their next visit.
 */
export const useCommandPaletteStore = create<CommandPaletteState>()((set) => ({
  open: false,
  setPaletteOpen: (open) => set({ open }),
  openPalette: () => set({ open: true }),
  togglePalette: () => set((state) => ({ open: !state.open })),
}))
